// extracted by mini-css-extract-plugin
module.exports = {"addresses":"ShippingAddresses_addresses__2LFRq"};